const topicListReducer = (state = [], action) => {
    switch (action.type) {
        case 'CHANGE_TOPIC':
            return {...state, ...action.body};
        case 'SAVE_COLORS':
            return {...state, ...action.topicColors};
        case 'SET_TOPIC':
            return {...state, ...action.selectedTopic};
        default:
            return state
    }
};

export default topicListReducer;